<template>
    <div class="qualityList">
        <table class="gradeTable">
            <tbody>
            <tr class="title">
                <th>序号</th>
                <th>活动类别</th>
                <th>活动名称</th>
                <th>组织单位</th>
                <th>添加时间</th>
                <th>操作</th>
            </tr>
            <tr  v-for="(value,index) in list" :key="index" >
                <td>{{index + 1 + (pageData.current-1)*pageData.pageSize}}</td>
                <td>{{value.typeName}}</td>
                <td>{{value.name}}</td>
                <td>{{value.organizationalUnit}}</td>
                <td>{{value.createdAt}}</td>
                <td class="btn goView" @click="goDetail(value.id)">
                    查看
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>
<script>
export default {
    name: "qualityList",
    components: {
    },
    props:['list','userType','pageData'],
    data() {
        return {

        }
    },
    methods: {
        goDetail(id) {
            if(this.userType==1) {
                this.$router.push({path:'/studyPlan/studentMessage/quality/detail',query:{id: id}})
            }
            if(this.userType==2) {
                this.$router.push({path:'/parent/main/studentMessage/quality/detail',query:{id: id}})
            }
            if(this.userType==3) {
                this.$router.push({path:'/consultant/minestudent/main/studentMessage/quality/detail',query:{id: id}})
            }
        },
    }

}
</script>

<style scoped lang="less">
.qualityList {
    .gradeTable {
        width: 100%;
        tr.title {
            background: rgba(61, 144, 246, 0.2);
            border-radius: 5px;
            font-size: 16px;
            font-weight: bold;
            color: #333;
            th {
                text-align: center;
            }
        }
        tr {
            line-height: 40px;
            text-align: center;
            border-bottom: 1px solid #ECECEC;
            .goView {
                color: #0095EB;
                cursor: pointer;
            }
            th {
                font-weight: bold;
            }
        }

    }
}
</style>